/**
 * Sort games list by kick-off datetime
 */
document.addEventListener('DOMContentLoaded', function () {
  // Sort table rows (for EN version)
  const tables = document.querySelectorAll('.games-list-all__table tbody');
  tables.forEach((table) => {
    const rows = Array.from(table.querySelectorAll('tr[data-datetime]'));

    rows.sort((a, b) => {
      const dateA = a.getAttribute('data-datetime') || '';
      const dateB = b.getAttribute('data-datetime') || '';
      return dateA.localeCompare(dateB);
    });

    rows.forEach((row) => table.appendChild(row));
  });

  // Sort div items (for JP version)
  const containers = document.querySelectorAll('.games-list-all__items');
  containers.forEach((container) => {
    const items = Array.from(container.querySelectorAll('div[data-datetime]'));

    items.sort((a, b) => {
      const dateA = a.getAttribute('data-datetime') || '';
      const dateB = b.getAttribute('data-datetime') || '';
      return dateA.localeCompare(dateB);
    });

    items.forEach((item) => container.appendChild(item));
  });
});
